// extracted by mini-css-extract-plugin
export default {"productGrid":"P0-z","centerLink":"Q0-z","productSection":"R0-z","item":"S0-z","ctaButton":"T0-z"};